import React, { Component } from "react";

import "HELPDESK/Components/QueryDetails/ViewRequestModal/EnhancementVerticalStepper/enhancementverticalstepper.css";
import customerMicrophone from "HELPDESK/CommonResources/images/customerMicrophone.png";
import handIcon from "HELPDESK/CommonResources/images/handIcon.png";
import developmentIcon from "HELPDESK/CommonResources/images/developmentIcon.svg";
import closureConfirmationIcon from "HELPDESK/CommonResources/images/closureConfirmation.svg";
import closureIcon from "HELPDESK/CommonResources/images/customerMicrophone.png";
import { toast } from "react-toastify";
import HelpdeskApiCall from "HelpdeskApiCall";
import config from "config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
class EnhancementVerticalStepper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentQueryRequestId: this.props.currentQueryRequestId,
            transactionList: {},
            workflowStatusList: {},
            workflowStatusFetching: false,
        };
    }


    componentDidMount() {
        this.apiCallToGetTransactionHistory();
    }

    apiCallToGetTransactionHistory = async () => {
        // this.setState({
        //     executiveResponseFetching: true,
        // })
        const requestData = {
            serviceRequestId: this.state.currentQueryRequestId,
            // updatedBy: config.userId

        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'helpDesk_getClientServiceRequestStatusHistory',
            requestData,
            '/api/helpDesk/clientServiceRequest/help_deskClientServiceRequest.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetTransactionHistory();
            }, 1000);
        } else {
            if (jsonResponse.success) {

                let apiResult = jsonResponse.APIResult.data;
                let sequenceArray = jsonResponse.APIResult.sequence;


                let sequenceObjectArray = [];
                sequenceArray.forEach((seq) => {
                    if (apiResult[seq]) {
                        sequenceObjectArray.push(apiResult[seq]);
                    }
                });

                this.setState({ transactionList: sequenceObjectArray });

            } else {

                toast.error(jsonResponse.message)
                this.setState({ transactionList: {} });
            }
        }
    }

    viewStatusModal = (allCCNames) => {
        // Ensure it's an array (if it's a comma-separated string)
        const namesArray = typeof allCCNames === 'string'
            ? allCCNames.split(',').map(name => name.trim())
            : allCCNames;

        return (
            <div
                style={{

                    width: '200px',
                    height: '400px',
                    overflowY: 'auto',
                    background: '#FFFFFF',
                    color: '#000000',
                    padding: '20px',
                    boxShadow: '0 0 10px rgba(0,0,0,0.3)',
                    borderRadius: '10px',
                    zIndex: 1000
                }}
            >
                {namesArray.map((name, index) => (
                    <p key={index} style={{ margin: '8px 0' }}>
                        {name}
                    </p>
                ))}

            </div >
        );
    }

    viewCurrentQueryStatusOnHover = (transaction) => {

        return (
            <div
                style={{

                    width: '200px',
                    height: '200px',
                    overflowY: 'auto',
                    background: '#FFFFFF',
                    color: '#000000',
                    padding: '20px',
                    boxShadow: '0 0 10px rgba(0,0,0,0.3)',
                    borderRadius: '10px',
                    zIndex: 1000
                }}
            >
                <div style={{ display: 'flex', flexDirection: 'row', gap: '7px', height: '100%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>


                        {transaction?.statusHistory?.transitionStatus ? (
                            <span className={`request-circle ${transaction?.statusHistory?.transitionStatus === "completed" ? "completed" : "new"}`}>
                                ✔
                            </span>
                        ) : (
                            <span className={`request-circle ${transaction?.isNextStatus === "true" ? "in-progress" : "new"}`}>
                                ✔
                            </span>
                        )}

                    </div>

                    <div className="innerBoardStepper">
                        <FontAwesomeIcon icon={transaction?.icons} alt={transaction?.statusName} style={{ height: '24px', width: '24px', marginTop: '10px' }} />
                        <span className="vm_custom_body10">  {transaction.statusName}</span>
                        {transaction?.statusHistory &&
                            !Array.isArray(transaction.statusHistory) &&
                            Object.keys(transaction.statusHistory).length > 0 && (
                                <>
                                    <p className="vm_custom_body4" style={{ color: '#1E1E1E' }}>Created on</p>
                                    <p className="vm_custom_body4" style={{ color: '#808080' }}>
                                        {transaction.statusHistory.readableCreatedOn || "N/A"}
                                    </p>
                                    <p className="vm_custom_body4" style={{ color: '#808080' }}>{transaction?.statusHistory?.transitionByName}</p>
                                </>
                            )}
                    </div>
                </div>


            </div >
        );
    }

    render() {
        return (
            <div className="d-flex flex-column" style={{ gap: '6px' }}>

                <div className="d-flex align-items-center flex-row stepper-container">
                    {Object.values(this.state.transactionList).length > 0 &&
                        Object.values(this.state.transactionList).map((transaction, index) => {
                            const isCompleted = transaction?.statusHistory?.transitionStatus === "completed";
                            const isInProgress = transaction?.isNextStatus === "true";

                            return (
                                <Tippy
                                    key={index} // 👉 move `key` here (important warning fix)
                                    content={this.viewCurrentQueryStatusOnHover(transaction)}
                                    placement="left-start"
                                    interactive={true}
                                    className="tooltip-custom-tippy"
                                >
                                    <span
                                        className={`step-cell ${isCompleted ? "completed" : isInProgress ? "in-progress" : "new"}`}
                                    >
                                       <span className="vm_custom_body9"> {index+1}</span>
                                    </span>
                                </Tippy>
                            );
                        })}
                </div>

                <div className="container" style={{marginBottom:'16px'}}>

                    {
                        Object.values(this.state.transactionList).length > 0 &&
                        Object.values(this.state.transactionList).map((transaction, index) => (
                            <div key={index} className="d-flex align-items-start mb-4">
                                <div className="ms-3">
                                    {/* {index === 0 || (steps[transaction.statusName] && steps[index - 1]?.phase !== steps[transaction.statusName]?.phase) ? ( */}
                                    <p className="vm_custom_overline1" style={{ color: '#8F9AA3', marginBottom: '10px' }}>
                                        Phase {Math.ceil((index + 1))} - {transaction.statusName}
                                    </p>
                                    {/*  ) : null} */}

                                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px', height: '100%' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>


                                            {transaction?.statusHistory?.transitionStatus ? (
                                                <span className={`request-circle ${transaction?.statusHistory?.transitionStatus === "completed" ? "completed" : "new"}`}>
                                                    ✔
                                                </span>
                                            ) : (
                                                <span className={`request-circle ${transaction?.isNextStatus === "true" ? "in-progress" : "new"}`}>
                                                    ✔
                                                </span>
                                            )}

                                        </div>

                                        {/* Icon */}
                                        <div className="innerBoardStepper">
                                            {/* <img src={transaction?.icons} alt={transaction?.statusName} style={{ height: '24px', width: '24px', marginTop: '10px' }} /> */}
                                            <FontAwesomeIcon icon={transaction?.icons} alt={transaction?.statusName} style={{ height: '24px', width: '24px', marginTop: '10px' }} />
                                            <p className="vm_custom_subtitle5" style={{ color: '#000000' }}>{transaction?.statusLabelName}</p>

                                            {(transaction?.isNextStatus === "true" && transaction?.pendingByPerson) && <>
                                                <p className="vm_custom_body4" style={{ color: '#1E1E1E' }}>Pending by</p>
                                                <span style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>
                                                    <span className="vm_custom_body4">
                                                        {transaction?.pendingByPerson?.split(',').slice(0, 2).join(', ')}
                                                    </span>
                                                    <Tippy content={this.viewStatusModal(transaction?.pendingByPerson)} placement="left-start" interactive={true}
                                                        className="tooltip-custom-tippy"
                                                    >
                                                        <span className="vm_custom_body4" style={{ textDecoration: 'underline', background: 'none', border: 'none', color: '#0465ac', cursor: 'pointer', fontWeight: 'bold' }}>
                                                            View More
                                                        </span>
                                                    </Tippy>
                                                </span>
                                            </>
                                            }
                                            {/* handle if status is  */}
                                            {transaction?.statusHistory &&
                                                !Array.isArray(transaction.statusHistory) &&
                                                Object.keys(transaction.statusHistory).length > 0 && (
                                                    <>
                                                        <p className="vm_custom_body4" style={{ color: '#1E1E1E' }}>Created on</p>
                                                        <p className="vm_custom_body4" style={{ color: '#808080' }}>
                                                            {transaction.statusHistory.readableCreatedOn || "N/A"}
                                                        </p>
                                                        <p className="vm_custom_body4" style={{ color: '#808080' }}>{transaction?.statusHistory?.transitionByName}</p>
                                                    </>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>

            </div>
        );
    }
}

export default EnhancementVerticalStepper;
